module.exports = __webpack_public_path__ + "static/assets/05049991b8bdd02953cb06416819b07b.png";